import React from 'react';

import { useListPartnersQuery } from '../../../api/partners';
import { v9 } from '../v9';

interface PartnerSelectProps {
	id: string;
	// The partner id; '' is no partner.
	value: string;
	onChange: (partnerId: string) => void;
	emptyLabel?: string;
}

// Partners come from Settings › Partners (ROC-117); new ones are added there.
const PartnerSelect: React.FC<PartnerSelectProps> = ({
	id,
	value,
	onChange,
	emptyLabel = '—',
}) => {
	const { data: partners = [] } = useListPartnersQuery();

	return (
		<select
			id={id}
			className={v9.input}
			value={value}
			onChange={(e) => onChange(e.target.value)}
		>
			<option value="">{emptyLabel}</option>
			{partners.map((partner) => (
				<option key={partner.id} value={partner.id}>
					{partner.name}
				</option>
			))}
		</select>
	);
};

export default PartnerSelect;
